var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4828 7.65156L17.3945 7.27695H9.25234V10.723H14.1172C13.6121 13.1215 11.2684 14.384 9.35391 14.384C7.96094 14.384 6.49258 13.798 5.5207 12.8562C5.00794 12.3514 4.59979 11.7504 4.31961 11.0876C4.03943 10.4248 3.89272 9.7133 3.88789 8.99375C3.88789 7.54219 4.54023 6.09023 5.48945 5.13516C6.43867 4.18008 7.87227 3.6457 9.29766 3.6457C10.9301 3.6457 12.1 4.5125 12.5375 4.90781L14.9863 2.47187C14.268 1.84062 12.2945 0.25 9.21875 0.25C6.8457 0.25 4.57031 1.15898 2.90703 2.8168C1.26562 4.44922 0.416016 6.80977 0.416016 9C0.416016 11.1902 1.21992 13.4328 2.81055 15.0781C4.51016 16.8328 6.91719 17.75 9.3957 17.75C11.6508 17.75 13.7883 16.8664 15.3117 15.2633C16.8094 13.6852 17.584 11.5016 17.584 9.2125C17.584 8.24883 17.4871 7.67656 17.4828 7.65156Z",
    fill: "#CAD0E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.ea720c04a97266dce0ba59422159880c.svg";
export { ForwardRef as ReactComponent };